import React, {useEffect, useMemo, useState} from "react";
import {getAbandonedCheckoutsPreview} from "../../api/getAbandonedCheckoutsPreview";
import useUserContext from "../../hooks/useUserContext";
import {formatDate, formatDateForAmPmDisplay, formatDateNoTime} from "../../utils/friendlyDate";
import "./dashboard-preview.css";
import {Button, Tooltip} from "antd";
import LongArrowRight from "../../assets/icons/LongArrowRight";
import {EyeOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import SkeletonItem from "../skeleton/SkeletonItem";
import Skeleton, {SkeletonRow, SkeletonTableRow} from "../skeleton/Skeleton";
import {getMessagesLogPreview} from "../../api/getMessagesLogPreview";
import DashboardPreviewRow from "./DashboardPreviewRow";
import getCampaignPreviewList from "../../api/getCampaignPreviewList";
import useAppContext from "../../hooks/useAppContext";
import millify from "millify";
import EmptyState from "../emptyState/EmptyState";
import {PlusIcon} from "../../assets/icons/PlusIcon";
import Loader from "../loader/Loader";

interface DashboardPreviewProps {
    title?: string;
    route: string;
    onNewCampaignClick: () => void;
}

const DashboardCampaignPreview = ({ title, route, onNewCampaignClick }: DashboardPreviewProps) => {
    const { data: { campaigns }} = useAppContext();
    const [isLoading] = useState(false);
    const navigate = useNavigate();
    const sentCampaigns = useMemo(() => campaigns.data.filter((c: any) => c.state === 'sent').slice(0,5), [campaigns]);

    const goToRoute = () => {
        navigate(`/${route}`);
    }

    if(isLoading) return <div className="chart-container dashboard-preview">
        {title ? <div className="chart-title">
            {title}
        </div> : null}
        <div className="preview-loader-container">
            <SkeletonTableRow opacity={4} />
            <SkeletonTableRow opacity={3} />
            <SkeletonTableRow opacity={2} />
        </div>
        <div className="preview-footer" />
    </div>

    return (
        <div className="chart-container dashboard-preview">
            {title ? <div className="chart-title">
                {title}
            </div> : null}
            {campaigns.isLoading ? <Loader/> : <div className="flex1">
                {sentCampaigns?.length ? <div className="campaign-preview-rows">
                        {sentCampaigns?.map((row: any) => <div className="row flex" key={`campaign-preview-row-${row.id}-${row.title}`}>
                            {/*<div className="flex2"><Tooltip title={formatDateForAmPmDisplay(new Date(row.created_at))}>{formatDateNoTime(new Date(row.created_at))}</Tooltip></div>*/}
                            {/*<div className="flex1">{row.checkout_id}</div>*/}
                            <div className="flex4">{row.title}</div>
                            {row.insights.orders ? <div className="flex2"><span
                                    className="status recovered">{row.insights.orders} Converted</span></div> :
                                row.insights.uniqueClicks ? <div className="flex2"><span
                                        className="status recoverable">{row.insights.uniqueClicks} Clicked</span></div> :
                                    row.insights.read ? <div className="flex2"><span
                                            className="status recoverable">{row.insights.read} Read</span></div> :
                                        <div className="flex2"><span
                                            className="status recoverable">{row.insights.delivered} Delivered</span></div>
                            }

                            <div className="flex2">${millify(row.revenue * 100 / 100)} Revenue</div>
                            {/*<div className="flex2">{row.future_messages}</div>*/}
                        </div>)}
                    </div> :
                    <EmptyState
                        className="dashboard-campaign-preview-empty-state"
                        title="No Campaigns Yet"
                        subTitle=""
                        actions={<Button onClick={onNewCampaignClick} className="empty-state-text-button" size="small"
                                         type="text">Create a New Campaign</Button>}
                    />}
            </div>}
            {sentCampaigns?.length ? <div className="preview-footer">
                <div onClick={goToRoute}><EyeOutlined width={10} color="#1575fb" /> <span>View All</span></div>
            </div> : null}
        </div>
    );
}

export default DashboardCampaignPreview;